import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, watchEffect } from 'vue'
import Popper from 'vue3-popper'

import { TOOLTIP_OPEN_DELAY } from '@/shared/config'

export type TooltipAction = 'hide' | 'show'
export type TooltipPlacement =
  | 'auto'
  | 'auto-start'
  | 'auto-end'
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    value: { default: '' },
    offsetDistance: { default: '12' },
    placement: { default: 'bottom' },
    action: { default: undefined },
    hidden: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const isVisible = ref(false)
const timeout = ref()

const handleMousenter = () => {
  isVisible.value = false

  timeout.value = setTimeout(() => {
    isVisible.value = true
  }, TOOLTIP_OPEN_DELAY)
}

const handleMouseleave = () => {
  isVisible.value = false
  clearTimeout(timeout.value)
}

onMounted(() => {
  clearTimeout(timeout.value)
})

watchEffect(() => {
  if (props.action) {
    ;({
      hide: () => {
        isVisible.value = false
      },
      show: () => {
        isVisible.value = true
      },
    })[props.action]()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popper), {
    content: props.value,
    show: isVisible.value && !props.hidden,
    "offset-distance": _ctx.offsetDistance,
    placement: _ctx.placement,
    "data-testid": "tooltip",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (handleMousenter())),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (handleMouseleave()))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["content", "show", "offset-distance", "placement"]))
}
}

})